<template>
  <a-card>
    <span slot="title"><a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
      Pencairan Financing</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Detail Pembayaran" />
    </a-steps>
    <div class="steps-content flex-1" :class="steps[current].content == 'Detail' ? 'padding-remove border-none' : ''
      ">
      <component class="flex-1" :is="steps[current].content" :ref="stepRef" v-bind="stepProps"></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
        <a-button v-if="current == steps.length - 1" :disabled="$refs.detailForm && $refs.detailForm.changeDetail.status"
          type="primary" :loading="loading.submit" @click="validate" icon="save">Save</a-button>
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import Information from "./steps/Information.vue";
import Detail from "./steps/Detail.vue";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "create-financing",
  props: ["id"],
  components: {
    Information,
    Detail,
  },
  mixins: [GlobalMethod],
  data() {
    return {
      current: 0,
      mode: "Create",
      loading: {
        submit: false,
      },
      dataProcessed: {
        information: {},
      },
      steps: [
        {
          title: "Information",
          content: "Information",
        },
        {
          title: "Detail Pembayaran",
          content: "Detail",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDateTimeStandartFormat",
      "getStandartFormatDate",
      "getDataProcessed",
      "getPenarikanInformationFinancing",
    ]),
    stepProps: function () {
      if (this.steps[this.current].content === "Information") {
        return {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
        };
      } else if (this.steps[this.current].content === "Detail") {
        return {
          mode: this.mode,
        };
      }
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Information") {
        return "refInformation";
      } else if (this.steps[this.current].content === "Detail") {
        return "refDetail";
      }
    },
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.$store.commit("setPageMode", "Edit");
    } else {
      this.mode = "Create";
      this.$store.commit("setPageMode", "Create");
    }
  },
  methods: {
    moment,
    fetch() {
      if (this.mode === "Edit") {
        this.$store
          .dispatch("getPenarikanFinanceEdit", {
            auth: this.getAuth,
            params: {
              tlc: this.getAuth.username,
              id_penarikan_financing: this.id,
            },
          })
          .then((response) => {
            let files = []
            if (response.data.informasi[0].document_file != null) {
              let typefile = this.fileTypeFromUrl(response.data.informasi[0].file_support);
              let file = this.dataURLtoFile(typefile + response.data.informasi[0].document_file, response.data.informasi[0].file_support);
              file.uid = 'vc-upload-1-1';
              file.status = 'done';
              file.exist = true;
              file.url = this.$serviceUrl + response.data.informasi[0].document_path;
              files.push(file);
            }

            const information = {
              contract_no: response.data.informasi[0].contract_no,
              create_dt: response.data.informasi[0].create_dt,
              description: response.data.informasi[0].description,
              financing_no: response.data.informasi[0].financing_no,
              id_penarikan_financing:
                response.data.informasi[0].id_penarikan_financing,
              no_transaksi: response.data.informasi[0].no_transaksi,
              tgl_permohonan: response.data.informasi[0].tanggal_permohonan,
              value: response.data.informasi[0].value,
              provisi_value: response.data.informasi[0].provisi_value,
              admin_value: response.data.informasi[0].admin_value,
              no_permohonan: response.data.informasi[0].no_permohonan,
              file_support: files.length == 0 ? null : files
            };

            if (response.data.detil_pembayaran.length > 0) {
              let totalPokok = 0;
              response.data.detil_pembayaran.forEach((data) => {
                const dataPembayaran = {
                  bulan: data.bulan,
                  bulan_tahun: data.bulan_tahun,
                  bunga: data.bunga,
                  can_edit: data.can_edit,
                  create_dt: data.create_dt,
                  id: data.id,
                  type: data.pokok == 0 ? 'bunga' : 'pokok',
                  pokok: data.pokok,
                  seq_no: data.seq_no,
                  tahun: data.tahun,
                  tlc_create: data.tlc_create,
                  total: data.total_value,
                };
                totalPokok = totalPokok + Number(data.pokok);
                this.$store.commit("setDetail", dataPembayaran);
              });
              this.$store.commit("setTotalPokok", totalPokok);
            }

            const initial = {
              contract: response.data.contract,
              financing: response.data.financing,
            };
            this.$store.commit("setinitial", initial);
            this.$store.commit("setInformation", information);
          });
      }
    },
    next() {
      if (this.steps[this.current].content === "Information") {
        this.$refs.refInformation.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      if (this.getDataProcessed.detail.length == 0) {
        this.displayMessageValue("basic-error", "Detail Cannot Empty!");
        return;
      }

      if (
        this.getDataProcessed.information.value -
        this.getDataProcessed.total_pokok !==
        0
      ) {
        this.displayMessageValue(
          "basic-error",
          "Total pokok harus sama dengan jumlah value"
        );
        return;
      }

      this.$refs.refDetail.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Information") {
        this.current++;
      } else {
        this.submit();
      }
    },
    submit() {
      let formData = new FormData();
      this.getDataProcessed.detail.forEach((data, index) => {
        formData.append(`bulan[${index}]`, data.bulan);
        formData.append(`bunga[${index}]`, data.bunga);
        formData.append(`id[${index}]`, data.id);
        formData.append(`pokok[${index}]`, data.pokok);
        formData.append(`can_edit[${index}]`, data.can_edit);
        formData.append(`tahun[${index}]`, data.tahun);
        formData.append(`total[${index}]`, data.total);
      });
      if (this.mode === "Create") {
        this.loading.submit = true;
        formData.append("tlc", this.getAuth.username);
        formData.append("tanggal_permohonan", moment(this.getDataProcessed.information.tgl_permohonan).format(this.getStandartFormatDate));
        formData.append("financing_no", this.getDataProcessed.information.financing_no);
        formData.append("contract_no", this.getDataProcessed.information.contract_no ? this.getDataProcessed.information.contract_no : "");
        formData.append("value", this.getDataProcessed.information.value);
        formData.append("admin_value", this.getDataProcessed.information.admin_value);
        formData.append("provisi_value", this.getDataProcessed.information.provisi_value);
        formData.append("no_permohonan", this.getDataProcessed.information.no_permohonan);
        formData.append("description", this.getDataProcessed.information.description);
        formData.append("total_pokok", this.getDataProcessed.total_pokok);
        formData.append("file_support", this.getDataProcessed.information.file_support[0]);
        this.$store
          .dispatch("submitPenarikanFinancing", {
            auth: this.getAuth,
            payload: formData,
          })
          .then((res) => {
            this.displayMessage("success-save");
            this.loading.submit = false;
            this.$router.go(-1);
          });
      } else {
        this.loading.submit = true;
        formData.append("tlc", this.getAuth.username);
        formData.append("id_penarikan_financing", this.id);
        formData.append("description", this.getDataProcessed.information.description);
        formData.append("total_pokok", this.getDataProcessed.total_pokok);
        formData.append("admin_value", this.getDataProcessed.information.admin_value);
        formData.append("provisi_value", this.getDataProcessed.information.provisi_value);
        formData.append("no_permohonan", moment(this.getDataProcessed.information.no_permohonan).format(this.getStandartFormatDate));
        formData.append("file_support", this.getDataProcessed.information.file_support[0]);
        this.$store
          .dispatch("submitPenarikanFinancingEdit", {
            auth: this.getAuth,
            payload: formData,
          })
          .then((res) => {
            this.displayMessage("success-save");
            this.loading.submit = false;
            this.$router.go(-1);
          });
      }
    },
  },
  mounted() {
    this.fetch();
    Event.$on("dataProcessed", this.valueFromChild);
  },
  beforeDestroy() {
    Event.$off("dataProcessed", this.valueFromChild);
  },
};
</script>

<style lang="less">
.border-none {
  border: none;
}
</style>
